import { LitElement, html, css, unsafeCSS } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

@customElement('vxc-valuebox')
export class TValueBox extends LitElement {
    @property({ type: String, attribute: 'title' }) header = '';
    @property({ type: String, attribute: 'value' }) value: string = '';
    @property({ type: String, attribute: 'unit'  }) unit: string = '';
    @property({ type: String, attribute: 'icon'  }) icon: string = '';

    static styles = css`
        .container {
            display: flex; 
            border: 1px solid #CCC;
            -webkit-border-radius: 5px;
            border-radius: 5px;
            background-color: white;
        }

        .left {
            flex-grow: 1; /* Allows this div to grow and fill available space */
            display: flex; /* Enable Flexbox for stacking */
            flex-direction: column; /* Stack children vertically */
            align-items: flex-start; /* Align items to the left */
            justify-content: center; /* Center items vertically in the parent */
            padding: 1rem;
            height: 100px; /* Optional: Set a fixed height for demonstration */
        }

        .stacked-div {
            margin-bottom: 10px; /* Add spacing between stacked divs */
        }

        .title {
            font-size: .85rem;
        }

        .value {
            font-size: 2rem;
            font-weight: 500;
        }

        .unit {
            font-size: .8rem;
        }


        .right {
            display: flex; /* Enable Flexbox */
            align-items: center; /* Vertically center content */
            justify-content: center; /* Horizontally center content */
            padding: 10px;
            height: 100px; /* Optional: Set a fixed 
        }
   `;

    render() {
        console.log('valuebox', this.header)
        let value = isNaN(Number(this.value.trim()))? this.value : Number(this.value.trim()).toLocaleString('fr-FR') 
        return html`
            <div class="container">
                <div class="left">
                    <div class="stacked-div">
                        ${this.title || ''}
                    </div>
                    <div class="stacked-div">
                        <span class="value">${value}</span>
                        <span class="unit">${this.unit||''}</span>
                    </div>
                </div>
                <div class="right">
                    ${unsafeHTML(this.icon)}
                </div>
            </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'vxc-valuebox': TValueBox;
  }
}